import Vue from "vue";
import VueRouter from "vue-router";
import Store from "./js/vuex-store";
import VeeValidate from "vee-validate";
import { Validator } from "vee-validate";
import Vuex from "vuex";
import ProofOfMembership from "../project/components/proof-of-membership/ProofOfMembership.vue";

Vue.config.productionTip = false;

Vue.use(VeeValidate);

Vue.use(Vuex);

Vue.use(VueRouter);

const dict = {
  custom: {
    email: {
      regex: "Ange en giltig e-postadress"
    },
    orgnr: {
      regex: "Ange 10 siffror"
    },
  }
};

const dictempty = {
  custom: {
    email: {
      required: () => "Du måste ange en e-postadress"
    },
    orgnr: {
      required: () => "Du måste ange ett organisationsnummer"
    },
  }
};

Validator.localize("en", dict);
Validator.localize("en", dictempty);

const routes = [
  { path: "/", component: ProofOfMembership },
];
const Router = new VueRouter({ routes });

if (document.querySelector("#proof-of-membership")) {
  new Vue({
    el: "#proof-of-membership",
    store: Store,
    // store,
    router: Router,
    components: {
      ProofOfMembership
    },
  });
}
